import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { generalMessages } from '@tk/utilities/tk.messages';
import { NotificationType, sendNotification } from '@tk/utilities/tk.notification';

export default class TKClipboard extends TKCustomElementFactory {
    cursor: string;

    constructor() {
        super();

        this.cursor = this.getAttribute('data-tk-cursor') || 'pointer';
    }

    connectedCallback(): void {
        this.style.cursor = this.cursor;

        this.registerClickListener();
    }

    registerClickListener() {
        const onClick = this.copy.bind(this);

        this.pushListener({
            event: 'click',
            element: this,
            action: onClick,
        });
    }

    async copy() {
        try {
            await navigator.clipboard.writeText(this.textContent || '');
            sendNotification(NotificationType.SUCCESS, generalMessages.messageClipboard.text);
        } catch (error) {
            console.error('Error when copying to the clipboard:', error);
        }
    }
}
